const Tags = () => {
  return (
    <>
      <div className="flex">
        Para usar el nombre de la persona solicitante en la pregunta, se debe usar el siguiente
        formato: <strong>{'{{solicitante}}'}</strong>
      </div>
      <div className="flex">
        Para usar el domicilio de la persona solicitante en la pregunta, se debe usar el siguiente
        formato: <strong>{'{{domicilioSolicitante}}'}</strong>
      </div>
      <div className="flex">
        Para usar el nombre de la persona aval en la pregunta, se debe usar el siguiente formato:{' '}
        <strong>{'{{aval}}'}</strong>
      </div>
      <div className="flex">
        Para usar el domicilio de la persona aval en la pregunta, se debe usar el siguiente formato:{' '}
        <strong>{'{{domicilioAval}}'}</strong>
      </div>
      <div className="flex">
        Para usar el monto del credito solicitado, se debe usar el siguiente formato:{' '}
        <strong>{'{{monto}}'}</strong>
      </div>
    </>
  );
};
export default Tags;
